import isAfter from "date-fns/isAfter";
import parseISO from "date-fns/parseISO";
import subMonths from "date-fns/subMonths";

type SectionTone = {
  title: string;
  tag?: string;
  tagClassName?: string;
  bulletClassName?: string;
  isQuote?: boolean;
};

export const isWithinOneMonth = (dateValue?: string | null) => {
  if (!dateValue) return false;

  try {
    return isAfter(parseISO(dateValue), subMonths(new Date(), 1));
  } catch {
    return false;
  }
};

export const toTitle = (rawKey: string) =>
  rawKey
    .replace(/_/g, " ")
    .replace(/\b\w/g, (m) => m.toUpperCase())
    .trim();

export const asString = (value: any) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  return JSON.stringify(value);
};

export const getSectionTone = (rawKey: string): SectionTone => {
  const key = rawKey.toLowerCase();

  if (key === "consensus_bull_case") {
    return {
      title: "Consensus bull case",
      tag: "Bull",
      tagClassName: "bg-[#E7F8EE] text-[#16A34A]",
      bulletClassName: "bg-[#22C55E]",
    };
  }

  if (key === "consensus_bear_case") {
    return {
      title: "Consensus bear case",
      tag: "Bear",
      tagClassName: "bg-[#FEECEC] text-[#DC2626]",
      bulletClassName: "bg-[#EF4444]",
    };
  }

  if (key === "under_the_radar_risks_opportunities") {
    return {
      title: "Under-the-radar risks & opportunities",
      tag: "Watch",
      tagClassName: "bg-[#FEF3E2] text-[#B45309]",
      bulletClassName: "bg-[#F59E0B]",
    };
  }

  if (key === "killer_question" || key === "uncomfortable_question") {
    return {
      title: toTitle(rawKey),
      tag: "Ask on call",
      tagClassName: "bg-[#E1F8F8] text-smart-teal",
      isQuote: true,
    };
  }

  if (key === "specific_24_month_threat") {
    return {
      title: "Specific 24-month threat",
      tag: "Watch",
      tagClassName: "bg-[#FEF3E2] text-[#B45309]",
    };
  }

  if (key === "roic_vs_wacc_analysis") {
    return {
      title: "ROIC vs. WACC analysis",
    };
  }

  if (key === "pricing_power_and_stickiness") {
    return {
      title: "Pricing power & stickiness",
    };
  }

  if (key === "context_and_rationale") {
    return {
      title: "Context & rationale",
    };
  }

  return {
    title: toTitle(rawKey),
  };
};
